// extracted by mini-css-extract-plugin
export default {"titleFilters":"searchFilters_titleFilters__wjjzs","scrollContaint":"searchFilters_scrollContaint__JRJCy"};